import React, { useContext, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { Checkbox } from "semantic-ui-react";
import { UDContext } from "../../pages/admin/users/userDetails/UserDetails";
import UserRolesDropdown from "../dropdowns/UserRolesDropdown";
import { postMethod } from "../../requests";
import UserStatusesDropdown from "../dropdowns/UserStatusesDropdown";

const EditAccountUserData = (props) => {
    const { show, onClose, data, setShowDeleteAccountModal, sendActivationLink } = props;
    const [formChanged, setFormChanged] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const { checkServerData, showView, setAlerts } = useContext(BasicContext);
    const { reloadData } = useContext(UDContext);
    const { t } = useTranslation();
    const [user, setUser] = useState({
        role: data.user_role_code_list.split(", "),
        status: data.user_stat_code,
        longBooking: data.user_long_booking === "Y" ? true : false,
    });

    const updateData = async () => {
        const res = await postMethod("/edit-user-account-data", { user: user, userID: showView.params.userID });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.editedUserData"), fading: 1500, id: "edited" }]);
            onClose();
            reloadData();
        } else setBlockForm(false);
    };

    const sendData = (e) => {
        e.preventDefault();
        setAlerts([{ variant: "info", message: t("info.editingUserData") }]);
        setBlockForm(true);
        updateData();
    };

    const resetPassword = async () => {
        const res = await postMethod("/user-reset-password", { userID: showView.params.userID });
        if (checkServerData(res)) setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "reset" }]);
    };

    return (
        <Modal show={show} onHide={onClose} backdrop={formChanged ? "static" : true}>
            <Form onSubmit={sendData} autoComplete="off">
                <Modal.Header closeButton>
                    <Modal.Title>{t("users.editAccountUserData")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={12}>
                            <UserRolesDropdown
                                onChange={(v) => {
                                    setUser({ ...user, role: v });
                                    setFormChanged(true);
                                }}
                                value={user.role}
                                multiple
                                classN="mb-3"
                            />
                        </Col>
                        <Col xs={12}>
                            <UserStatusesDropdown
                                onChange={(v) => {
                                    setUser({ ...user, status: v });
                                    setFormChanged(true);
                                }}
                                value={user.status}
                                classN="mb-3"
                            />
                        </Col>
                        <Col xs={12}>
                            <Form.Group className="mb-3">
                                <Checkbox
                                    label={<label className="form-label">{t("addUserForm.longBooking")}</label>}
                                    id={`addUserFormLongBooking`}
                                    checked={user.longBooking}
                                    onChange={() => {
                                        setUser({ ...user, longBooking: !user.longBooking });
                                        setFormChanged(true);
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        {user.status === "NEW" ? (
                            <Col xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("users.activationLink")}</Form.Label>
                                    <p className="text-small">{t("users.activationLinkTxt")}</p>
                                    <Button variant="outline-secondary" onClick={() => sendActivationLink()}>
                                        {t("sendLink")}
                                    </Button>
                                </Form.Group>
                            </Col>
                        ) : user.status === "ACTIVE" || user.status === "DISABLED" ? (
                            <Col xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("users.resetPass")}</Form.Label>
                                    <p className="text-small mb-2">{t("users.resetPassTxt")}</p>
                                    <Button variant="outline-secondary" onClick={() => resetPassword()}>
                                        {t("resetPass")}
                                    </Button>
                                </Form.Group>
                            </Col>
                        ) : null}

                        <Col xs={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>{t("users.deletingAccount")}</Form.Label>
                                <p className="text-small mb-2">{t("users.deletingAccountTxt")}</p>
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setShowDeleteAccountModal(true);
                                    }}
                                >
                                    {t("deleteAccount")}
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={onClose}>
                        {t("cancel")}
                    </Button>
                    <Button variant="primary" type="submit" disabled={!formChanged || blockForm}>
                        {t("saveChanges")}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default EditAccountUserData;
